(() => {
  if (window.ArnavWhatsApp) return;
  const config = () => JSON.parse(document.querySelector('[data-arnav-whatsapp-config]')?.textContent || '{}');
  const value = (form, key) => form.elements.namedItem(`contact[${key}]`)?.value.trim() || '';
  function recipient(form) {
    return String(form.dataset.whatsappNumber || config().number || '').replace(/[\s()+-]/g, '');
  }
  function availability(form) {
    const valid = /^[1-9]\d{7,14}$/.test(recipient(form));
    if (!valid) {
      const status = form.querySelector('[data-whatsapp-status]');
      if (status) { status.hidden = false; status.textContent = config().unavailable; }
    }
    return valid;
  }
  function buildUrl(form, kind, payload) {
    if (!availability(form)) return null;
    const c = config();
    const lines = [c.intros[kind]];
    for (const [key, label] of Object.entries(c.labels)) {
      if (payload[key]) lines.push(`${label}: ${payload[key]}`);
    }
    if (kind === 'appointment') lines.push(c.appointmentClosing);
    if (kind === 'application') lines.push(c.applicationClosing);
    return `https://wa.me/${recipient(form)}?text=${encodeURIComponent(lines.join('\n'))}`;
  }
  function submit(form, kind, payload) {
    const url = buildUrl(form, kind, payload);
    if (!url) return;
    // Opening WhatsApp prepares a message. Only the customer can send it.
    const status = form.querySelector('[data-whatsapp-status]');
    status.hidden = false;
    status.replaceChildren(document.createTextNode(config().review + ' '));
    const retry = document.createElement('a');
    retry.href = url; retry.target = '_blank'; retry.rel = 'noopener noreferrer';
    retry.className = 'arnav-editorial-link'; retry.textContent = config().open;
    status.append(retry);
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  function appointmentPayload(form) {
    const v = key => value(form, key);
    return { name: `${v('First Name')} ${v('Last Name')}`.trim(), title: v('Title'), email: v('email'), phone: v('phone'), city: v('City'), channel: v('Appointment Channel'), location: v('Appointment Location / Method'), purpose: v('Subject'), message: v('Message'), date: v('Appointment Date'), time: v('Appointment Time'), alternative_date: v('Alternative Date'), alternative_time: v('Alternative Time'), product: v('Interested Product'), product_url: v('Product URL'), profiling_consent: form.elements.namedItem('contact[Profiling Consent]')?.checked ? 'Yes' : 'No', marketing_consent: form.elements.namedItem('contact[Marketing Consent]')?.checked ? 'Yes' : 'No' };
  }
  function init() {
    document.querySelectorAll('[data-advisor-form]').forEach(form => {
      if (form.dataset.whatsappInitialized) return;
      form.dataset.whatsappInitialized = 'true';
      form.querySelector('[type=submit]').disabled = !availability(form);
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const v = key => value(form, key);
        submit(form, 'enquiry', { name: `${v('first_name')} ${v('last_name')}`.trim(), phone: v('country_code').replace('-CA', '') + ' ' + v('phone'), email: v('email'), city: v('city'), message: v('body'), source: location.pathname });
      });
    });
  }
  window.ArnavWhatsApp = { buildUrl, submit, appointmentPayload, availability };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
